import React, { FunctionComponent, useEffect, useState } from 'react';
import { CustomCheckbox } from '../../../common/components/MurphyCheckbox';
import { MBSRecipient } from '../apiAlert/models';
import SearchBar from '@murphy-frontend/web-core/components/SearchBar';

interface EventFlowChoosePermissionProps {
  recipients: MBSRecipient[];
  translations: Record<string, string>;
  removeRecipient?: (recipient: MBSRecipient) => void;
  clickRecipient?: (recipient: MBSRecipient) => void;
  addRecipient?: (recipient: MBSRecipient) => void;
}

const EventFlowChoosePermission: FunctionComponent<EventFlowChoosePermissionProps> = ({
  recipients,
  translations,
  clickRecipient,
  addRecipient,
}) => {
  const [searchText, setSearchText] = useState('');
  const [recipientslist, setRecipientsList] = useState(recipients);

  useEffect(() => {
    if (searchText) {
      setRecipientsList(
        recipients.filter(
          (p) =>
            p.name?.toUpperCase().startsWith(searchText.toUpperCase()) ||
            p.email?.toUpperCase().startsWith(searchText.toUpperCase())
        )
      );
    } else {
      setRecipientsList(recipients);
    }
  }, [recipients, searchText]);

  // Check if there are any groups in recipientslist
  const hasGroups = recipientslist?.some((item) => item.isGroup);

  return (
    <div className="cr-container">
      <label className="cr-section-label">
        {translations.tmpAddUserGroup || 'Choose Users/Groups'}
      </label>

      <div className="cr-searchbar-container">
        <SearchBar
          val={searchText}
          showSearchIcon
          handleChange={(event) => setSearchText(event.target.value)}
          placeholder={translations['placeholder-lang-search-action']}
        />
      </div>

      <label className="cr-subsection-label">
        {translations.contactgrps || 'Contact groups'}
      </label>
      <div className="cr-group-container">
        {hasGroups ? (
          recipientslist?.map(
            (item) =>
              item.isGroup && (
                <div key={item.name || item.uniqueKey} className="cr-button-container">
                  <CustomCheckbox
                    onChange={() => addRecipient?.(item)}
                    checked={item?.isAdded}
                    checkedColor="#00A098"
                    unCheckedColor="#7F7F7F"
                  />
                  <label
                    onClick={() => clickRecipient?.(item)}
                    style={{
                      marginLeft: 10,
                      overflow: 'hidden',
                      width: '20rem',
                      textOverflow: 'ellipsis',
                      cursor: 'pointer',
                    }}
                  >
                    {item.name} ({item.groupMembers?.length || 0})
                  </label>
                </div>
              )
          )
        ) : (
          <p
            style={{
              margin: '10px 0',
              color: '#7F7F7F',
              fontSize: '14px',
              fontStyle: 'italic',
            }}
          >
            {translations.tmpNoContactGroups || 'No contact groups available'}
          </p>
        )}
      </div>

      <label className="cr-subsection-label">
        {translations.tmpAddUser || 'Users'}
      </label>
      <div className="cr-recipient-container">
        {recipientslist?.map(
          (item) =>
            !item.isGroup && (
              <div key={item.name || item.uniqueKey} className="cr-contacts-container">
                <div className="cr-contact-left">
                  <CustomCheckbox
                    onChange={() => addRecipient?.(item)}
                    checked={item?.isAdded}
                    checkedColor="#00A098"
                    unCheckedColor="#7F7F7F"
                  />
                  <label className="cr-label-truncate">{item.name || 'Unknown User'}</label>
                </div>
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default EventFlowChoosePermission;